import { ContextModalProps } from '@mantine/modals'
import { UpdatePasswordForm } from 'components/settings/UpdatePasswordForm'
import { useUpdatePassword } from 'hooks/auth'
import { UpdatePassword } from 'types/auth'

type Props = {
  userId: string
}

export default function UpdatePasswordModal({ context, id, innerProps: { userId } }: ContextModalProps<Props>) {
  const updatePassword = useUpdatePassword()

  return (
    <UpdatePasswordForm
      onSubmit={async (values: UpdatePassword) => {
        await updatePassword.mutateAsync({ ...values, id: userId })
      }}
      onCancel={() => context.closeModal(id)}
    />
  )
}
